import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import {AppService} from "@irb/app.service";
import {IrbAppEvents} from '@irb-common/events';

@Injectable({
  providedIn: 'root'
})
export class IrbAgGridExportService {
    exportOptions: any = {
        isGridRequired:false, 
        gridOptions:{}
    };

    private prefix: string;
    private fileName: string;

    constructor(private datePipe: DatePipe, private as: AppService) {
        this.setPrefix("Untitled");
    }

    setPrefix(prefix: string, ext?: string) {
        const extension = ext || "xlsx";
        this.prefix = prefix;
        this.fileName = this.prefix + "_" + this.datePipe.transform(Date.now(), 'MM_dd_yyyy') + "." + extension;
    }

    getFileName() {
        return this.fileName;
    }

    setFileName(s: string) {
        this.fileName = s;
    }

    setExportOptions(res: any, gridApi: any, gridOptions: any, columnDefs: any, _columnKeys?: Array<string>, _customHeader?: Array<any>) {
        let columnKeys: Array<string> = [];

        if(_columnKeys) {
            columnKeys = _columnKeys;
        } else {
            gridApi.getAllDisplayedColumns().forEach((node: any) => {
                columnKeys.push(node.colId);
            });
        }

        this.exportOptions.isGridRequired = (res.length) ? true : false;
        this.exportOptions.gridOptions.rowData = res;        
        this.exportOptions.gridOptions.gridOptionscacheBlockSize = res.length;
        this.exportOptions.gridOptions.columnDefs = columnDefs;
        this.exportOptions.gridOptions.excelStyles = gridOptions.excelStyles;

        this.exportOptions.gridOptions.excelSheetParams = {
          fileName: this.fileName,      
          sheetName: this.fileName,
          columnKeys: columnKeys,
          skipHeader: _customHeader || false,
          customHeader: _customHeader,
          suppressQuotes : true
        };
    }

    getExportOptions() {
        return this.exportOptions;
    }
    
    resetExportGrid() {
        this.exportOptions.isGridRequired =  false;
    }
    
    download(res: Blob) {
        const blob: any = new Blob([(res)],{type:'application/vnd.openxmlformats-offdocument.spreadsheetml.sheet'});        
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = this.fileName;
        link.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true,view:window})); 
    }

    showSuccessMessage() {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary:'Export submitted',
            detail: 'Use the download icon to retrieve your exports (top right of screen)',
            life: 5000
        });
    }
}
